import React, { createContext, useContext } from "react";

interface AddJobContextProps {
  jobId: string;
  expertId: string;
  sourcingType: string;
  isEdit: boolean;
  setLoading: (val: boolean) => void;
  handleSetJobId: (jobId: string, step: string) => void;
  jobTitle : string;
  setJobTitle: (title:"string") => void;
}

const AddJobContext = createContext<AddJobContextProps | null>(null);

export const useAddJobContext = () => {
  const ctx = useContext(AddJobContext);
  if (!ctx) throw new Error("AddJobContext must be used within a Provider");
  return ctx;
};

export const AddJobProvider = AddJobContext.Provider;